{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversas selecionadas",
    "NONE": "Nenhuma",
    "CLEAR_SELECTION": "Limpar",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Tem certeza de que deseja atribuir {n} conversa para {agentName}? | Tem certeza de que deseja atribuir {n} conversas para {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Tem certeza de que deseja remover a atribuição de {n} conversa? | Tem certeza de que deseja remover a atribuição de {n} conversas?",
    "YES": "Sim",
    "CANCEL": "Cancelar",
    "SEARCH_INPUT_PLACEHOLDER": "Pesquisar",
    "ASSIGN_AGENT_TOOLTIP": "Atribuir Agente",
    "ASSIGN_TEAM_TOOLTIP": "Atribuir time",
    "ASSIGN_SUCCESFUL": "Conversas atribuídas com sucesso.",
    "ASSIGN_FAILED": "Falha ao atribuir conversas. Por favor, tente novamente.",
    "RESOLVE_SUCCESFUL": "Conversas resolvidas com sucesso.",
    "RESOLVE_FAILED": "Falha ao resolver conversas. Por favor, tente novamente.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversas visíveis nesta página só estão selecionadas.",
    "UPDATE": {
      "CHANGE_STATUS": "Alterar status",
      "SNOOZE_UNTIL": "Adiar",
      "UPDATE_SUCCESFUL": "Status da conversa atualizado com sucesso.",
      "UPDATE_FAILED": "Falha ao atualizar conversas. Por favor, tente novamente."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Não é possível resolver a conversa devido à ausência de atributos obrigatórios",
      "PARTIAL_SUCCESS": "Algumas conversas exigem atributos obrigatórios antes da resolução e foram ignoradas"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Atribuir rótulo",
      "REMOVE_LABELS": "Remover etiquetas",
      "ASSIGN_SELECTED_LABELS": "Atribuir etiquetas selecionadas",
      "REMOVE_SELECTED_LABELS": "Remover etiquetas selecionadas",
      "ASSIGN_SUCCESFUL": "Rótulos atribuídos com sucesso.",
      "ASSIGN_FAILED": "Falha ao atribuir etiquetas. Por favor, tente novamente.",
      "REMOVE_SUCCESFUL": "Etiquetas removidas com sucesso.",
      "REMOVE_FAILED": "Falha ao remover etiquetas. Por favor, tente novamente."
    },
    "TEAMS": {
      "NONE": "Nenhum",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Tem certeza de que deseja atribuir {n} conversa ao time {teamName}? | Tem certeza de que deseja atribuir {n} conversas ao time {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Tem certeza de que deseja remover a atribuição de {n} conversa? | Tem certeza de que deseja remover a atribuição de {n} conversas?",
      "ASSIGN_SUCCESFUL": "Times atribuídos com sucesso.",
      "ASSIGN_FAILED": "Falha ao atribuir time. Por favor, tente novamente."
    }
  }
}
